import { useQuery } from "react-query";
import * as api from "../api/easeedesk/apis";
import {useState} from "react";

const getTickets = async (options) => {
    return await api.fetchTickets(options);
};

export default function useTickets(options)
{
    const [page, setPage] = useState(1);

    return useQuery(['tickets', options], () => getTickets(options), { refetchOnWindowFocus: false });
}
